import { createIcon } from './icon';

export const ExpandIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 2h5v5" />
    <path d="M14 2l-5 5" />
    <path d="M7 14H2V9" />
    <path d="M2 14l5-5" />
  </svg>,
  'ExpandIcon'
);
